export * from './footer/footer.component';
export * from './loading-page/loading-page.component';
export * from './modal-error-message/modal-error-message.component';
export * from './modal-info-message/modal-info-message.component';
export * from './modal-success-message/modal-success-message.component';
export * from './modal-warning-message/modal-warning-message.component';
export * from './custom-snackbar/custom-snackbar.component';



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/layout/index.ts